import {Inject, Injectable} from "@angular/core";
import { WindowRefService } from '../window-ref.service';
import {AviaSearchParams, AviaSearchRequest} from "./interfaces/avia-search";
import {HttpHeaders} from "@angular/common/http";
import {APP_CONFIG, AppConfig} from "../../config/app.config";

@Injectable({
  providedIn: 'root',
})
export class AviaSearchService {
  constructor(
    @Inject(APP_CONFIG) private appConfig: AppConfig,
    private windowService: WindowRefService,
  ) {
  }

  getHeaders() {
    return new HttpHeaders({
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Authorization': `ApiKey ${this.appConfig.apiKey}`,
    })
  }

  createSearchRequest(queryParams: any): AviaSearchRequest {
    const params: AviaSearchParams = {
      origin: this.createDirectionParams(queryParams['departure'], queryParams['departureType']),
      destination: this.createDirectionParams(queryParams['destination'], queryParams['destinationType']),
      departureDate: queryParams['dateFrom'] || '',
      passengers: {
        adults: Number(queryParams['adults'] || 2),
        childAges: (queryParams['childAges'] || '').split(',').filter(Boolean).map(Number),
      },
      onlyDirectFlights: queryParams['onlyDirectFlights'] === 'true',
    };

    if (queryParams['dateTo']) {
      params.returnDate = queryParams['dateTo'];
    }

    this.windowService.nativeWindow.aviaSearchParams = params;

    return {params};
  }

  private createDirectionParams(code: string | null | undefined, type: string | null | undefined) {
    if (!this.appConfig.isPreview) {
      return {
        cityCode: code || '',
        airportCode: code || '',
      };
    }

    const normalizedCode = code || null;

    if (type === 'airport') {
      return {
        cityCode: null,
        airportCode: normalizedCode,
      };
    }

    return {
      cityCode: normalizedCode,
      airportCode: null,
    };
  }
}
